import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  const scrollToOffer = () => {
    const element = document.getElementById('offer');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 bg-accent-cream" data-id="element-60">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-61">
        <div className="w-20 h-20 bg-accent-gold rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg text-white" data-id="element-62">
          <ShieldCheck className="h-10 w-10" data-id="element-63" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-secondary mb-4" data-id="element-64">
          7 Días de Satisfacción Garantizada
        </h2>

        <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-65">
          Si el método no transforma tu relación con la comida, escríbenos a
          soporte y te devolvemos el{' '}
          <strong className="text-secondary" data-id="element-66">100% de tu dinero</strong>. Sin
          preguntas incómodas.
        </p>

        <button onClick={scrollToOffer} className="text-primary font-bold underline hover:text-primary-dark transition-colors" data-id="element-67">
          Probar el reset sin riesgo
        </button>
      </div>
    </section>;
}